import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { TimeAgoPipe } from "src/app/pipes/time-ago.pipe";
import { CommonModule } from "@angular/common";
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { ProjectHubTruncateService } from "../project-hub-content-truncate.service";
import { DxContextMenuModule } from "devextreme-angular";
import { UserAvatarComponent } from "src/app/components/user-avatar/user-avatar.component";
import { ItemClickEvent } from "devextreme/ui/context_menu";
import { SparkAnswerItem } from "../../project-hub.types";
import { ProjectHubService } from "src/app/services/project-hub.service";
import { ConfigService } from "src/app/services/config.service";
import { AppGlobals } from "src/app/app.globals";
import { AnswerEditorComponent } from "../answer-editor/answer-editor.component";

@Component({
    selector: "app-answer-card",
    templateUrl: "./answer-card.component.html",
    styleUrls: ["../spark-card.shared.css", "./answer-card.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TimeAgoPipe,
        CommonModule,
        SvgIconComponent,
        DxContextMenuModule,
        AnswerEditorComponent,
        UserAvatarComponent,
    ]
})
export class AnswerCardComponent implements AfterViewInit, OnDestroy {
  @Input() answer: SparkAnswerItem;

  @Input() selected: boolean = false;
  @Output() onEdit = new EventEmitter<SparkAnswerItem>();
  @Output() onUpdate = new EventEmitter<SparkAnswerItem>();
  @Output() onDelete = new EventEmitter<SparkAnswerItem>();

  @ViewChild("contentContainer")
  contentContainer: ElementRef;

  showFullContent = false;

  displayContent: string = "";
  isContentTruncated = false;

  // Inline editing properties
  isEditing = false;
  submittingEdit = false;

  contextMenuItems = [
    { text: $localize`:@@edit:Edit`, id: "edit" },
    { text: $localize`:@@delete:Delete`, id: "delete" },
  ];

  constructor(
    private truncateService: ProjectHubTruncateService,
    private cdr: ChangeDetectorRef,
    public configService: ConfigService,
    private elementRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    this.updateTruncation();
  }

  ngOnDestroy(): void {}

  private updateTruncation(): void {
    const truncatedContent = this.truncateService.truncateContent(
      this.contentContainer,
      this.answer.content
    );
    this.displayContent = truncatedContent.content;
    this.cdr.detectChanges();
  }

  toggleContent() {
    this.showFullContent = !this.showFullContent;
    this.updateTruncation();
  }

  onContextMenuItemClick(event: ItemClickEvent) {
    const action = (event.itemData as any).id;

    switch (action) {
      case "edit":
        this.startEditing();
        break;
      case "delete":
        this.onDelete.emit(this.answer);
        break;
    }
  }

  startEditing() {
    this.isEditing = true;
    this.onEdit.emit(this.answer); // Notify parent to move to top
    this.cdr.markForCheck();
  }

  async saveEdit(content: string) {
    this.submittingEdit = true;
    try {
      const updatedAnswer = {
        ...this.answer,
        content,
      };
      this.onUpdate.emit(updatedAnswer);
      this.isEditing = false;
    } catch (error) {
      AppGlobals.ShowErrorMessage(
        $localize`:@@internalServerError:Internal server error`
      );
    } finally {
      this.submittingEdit = false;
      this.cdr.markForCheck();
    }
  }

  cancelEdit() {
    this.isEditing = false;
    this.cdr.markForCheck();
  }
}
